import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const JOIN_PATH = /^\/groups\/join\/([ABCDEFGHJKLMNPQRSTUVWXYZ23456789]{6})\/?$/i;

function joinCodeFromPath(pathname) {
    const match = String(pathname || '').match(JOIN_PATH);
    return match ? match[1].toUpperCase() : null;
}

function isMobile() {
    return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent || '');
}

export function openJoinInApp(code) {
    const normalized = String(code || '').toUpperCase();
    const scheme = `clowza://groups/join/${normalized}`;
    const isAndroid = /Android/i.test(navigator.userAgent || '');
    if (isAndroid) {
        window.location.href = `intent://groups/join/${normalized}#Intent;scheme=clowza;package=com.clowza.app;end`;
        return;
    }
    window.location.href = scheme;
}

export default function OpenJoinInApp() {
    const location = useLocation();
    const code = joinCodeFromPath(location.pathname);
    const stayOnWeb = new URLSearchParams(location.search).get('web') === '1';

    useEffect(() => {
        if (!code || stayOnWeb || !isMobile()) return undefined;
        const isAndroid = /Android/i.test(navigator.userAgent || '');
        if (!isAndroid) return undefined;
        const key = `clowza-open-join-${code}`;
        try {
            if (sessionStorage.getItem(key)) return undefined;
            sessionStorage.setItem(key, '1');
        } catch (err) {
            return undefined;
        }
        const timer = setTimeout(() => openJoinInApp(code), 400);
        return () => clearTimeout(timer);
    }, [code, stayOnWeb]);

    if (!code || !isMobile()) return null;

    return (
        <div style={{
            position: 'sticky',
            top: 0,
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 12,
            padding: '12px 16px',
            background: '#1f6f62',
            color: '#fff',
        }}>
            <span style={{ fontSize: 14, lineHeight: 1.3 }}>
                Open this group in the Clowza app
            </span>
            <button
                type="button"
                onClick={() => openJoinInApp(code)}
                style={{
                    border: 0,
                    borderRadius: 8,
                    padding: '8px 14px',
                    background: '#fff',
                    color: '#1f6f62',
                    fontWeight: 700,
                    whiteSpace: 'nowrap',
                }}
            >
                Open app
            </button>
        </div>
    );
}
